import React, {Component} from 'react';

import AppMap from './components/AppMap'
import AppUserData from './components/AppUserData'
import './App.css';


class App extends Component {
    render() {
        return (
            <div className="fullHeight">
                <div className="position-relative fullHeight">
                    <div className="row fullHeight no-pad">
                        <AppMap/>
                        <AppUserData/>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
